(function () {
    'use strict';

    angular.module('pages.inventory.content', [
        'pages.inventory.content.pages',
        'pages.inventory.content.links',
        'pages.inventory.content.documents',
    ]);
})();
